<template>
  <div class="properties">
    <button @click="openPropertyDialog()" class="properties_add">+ Добавить свойство</button>
    <v-data-table
      :headers="headersProperties"
      :items="getProperty"
      :loading="getLoadingProperty"
      v-if="getProperty"
      hide-default-footer
      >
      <template v-slot:[`item.indicatorName`]="{ item }">
        <span v-if="!item.update">{{item.indicatorName}}</span>
        <v-text-field
          v-else
          v-model="item.indicatorName"
        ></v-text-field>
      </template>
      <template v-slot:[`item.indicatorValue`]="{ item }">
        <span v-if="!item.update">{{item.indicatorValue}}</span>
        <v-text-field
          v-else
          v-model="item.indicatorValue"
        ></v-text-field>
      </template>
      <template v-slot:[`item.propertyDGWs`]="{ item }">
        <span v-if="!item.update">
          {{
            item.propertyDGWs.map(item => {
              if (item.dataGetWay) return item.dataGetWay.wayName
            }).join(', ')
          }}
        </span>
        <v-autocomplete
          v-else
          ref="autocomplit"
          :items="getSearch"
          v-model="propertyDGWs"
          auto-select-first
          chips
          clearable
          deletable-chips
          multiple
          small-chips
        ></v-autocomplete>
      </template>
      <template v-slot:[`item.propertyMediaLinks`]="{ item }">
        <div v-if="!item.update">
          <span v-for="file in item.propertyMediaLinks" :key="file.mediaFileId">
             <span @click="viewing(file)" class="link" v-if="link(file)">
               {{file.mediaFile.fileName}}
             </span>
             <span @click="downloadFiles(file.mediaFile)" class="link" v-else>
               {{file.mediaFile.fileName}}
             </span>
          </span>
        </div>

        <div v-else>
          <p>{{selected.length == 1 ? selected[0].fileName : selected.map(item => {return item.fileName}).join(', ')}}</p>
          <v-btn @click="open()" class="mb-2">добавить файл</v-btn>
        </div>
      </template>
      <template v-slot:[`item.created`]="{ item }">
        <div class="d-flex" v-if="item.update">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                @click="saveEdit(item)"
                v-bind="attrs"
                v-on="on"
                class="mr-2"
              >
                mdi-content-save
              </v-icon>
            </template>
            <span>Сохранить</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                @click="removeEdit(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-close
              </v-icon>
            </template>
            <span>Отменить</span>
          </v-tooltip>
        </div>
        <div class="d-flex" v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="editProperty(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                @click="deleteProperty(item.id)"
                v-bind="attrs"
                class="mr-2"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800"
     >
     <div class="add-files">
      <div class="add-files-label">
        <div class="add-files_header">
          <h2>Добавить файл</h2>
          <button class="filter-btn" @click="close()">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
              <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="media-files_headline add-files-dialog">
          <div class="media-files_left">
            <div class="media-files_search">
              <label for="file">Поиск</label>
              <input
                id="file"
                v-model="search"
                class="media-files_search-input"
              />
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
              </svg>
            </div>

            <div class="media-files_switch">
              <label for="switch">Мои файлы</label>
              <v-switch
                v-model="filter.author"
                @change="mediaFilter(filter)"
                color="primary"
                id="switch"
                :value="userName"
                hide-details
              ></v-switch>
            </div>
            <div class="media-files_select">
              <label for="type">Тип файла</label>
              <v-select
                id="type"
                :items="mediaType"
                v-model="filter.fileType"
                class="media-files_search-select"
                hide-details
                @change="mediaFilter(filter)"
                outlined
              ></v-select>
            </div>
          </div>
        </div>
      <div class="table">

        <v-data-table
          v-model="selected"
          show-select
          :headers="headers"
          :items="mediaData"
          class="elevation-1"
          ref="table"
          @pagination="paginations($event)"
          :page="page"
          hide-default-footer
          :items-per-page="itemsPerPage"
          :search="search"
        >
        <template v-slot:[`item.mediaFileTags`]="{ item }">
          <span>{{item.mediaFileTags.map(item => {
            return item.mediaFileTag.tagName
          }).join(', ')}}</span>
        </template>

        <template v-slot:footer="{ props }">
          <div class="data-footer">
            <div class="items-per-page">
              <span>Строк на странице:</span>
              <div class="items-per-page_item" :class="{active: itemsPerPage == 5}" @click.prevent="itemsPerPage = 5">
                5
              </div>
              <div class="items-per-page_item" :class="{active: itemsPerPage == 10}" @click.prevent="itemsPerPage = 10">
                10
              </div>
              <div class="items-per-page_item" :class="{active: itemsPerPage == 15}" @click.prevent="itemsPerPage = 15">
                15
              </div>
              <div class="items-per-page_item" :class="{active: itemsPerPage == -1}" @click.prevent="itemsPerPage = -1">
                все
              </div>
            </div>
            <div class="pagination" v-if="itemsPerPage != -1">
              <div class="pagination_prev" @click.prevent="page == 1 ? page : --page">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
                </svg>
              </div>
              <div class="pagination_number">
                {{itemsPerPage * (page - 1) + 1}} - {{itemsPerPage * (page - 1) + itemsPerPage}} из {{props.pagination.itemsLength}}
              </div>
              <div class="pagination_next" v-if="itemsPerPage" @click.prevent="page == parseInt(props.pagination.itemsLength / itemsPerPage, 10) ? page : ++page">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
                </svg>
              </div>
            </div>
          </div>
        </template>
        </v-data-table>

        <button
          class="submit-add"
          @click="addFiles()"
        >
          Добавить
        </button>
      </div>
     </div>
    </div>
    </v-dialog>
    
    <v-dialog
      v-model="dialogProperty"
      max-width="500"
      persistent
      >
        <div class="add-files">
          <div class="add-files_header">
            <h2>Добавить свойство</h2>
            <button :disabled="loadingFileProperty" class="filter-btn" @click="closeDialogProperty()">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        <div class="form">
          <label class="add-files_form-label" for="desc">Показатель</label>
          <v-text-field
          id="desc"
          v-model="newProperty.iname"
          hide-details
          outlined
          required>
          </v-text-field>
          <label class="add-files_form-label" for="ivalue">Значение</label>
          <v-text-field
            id="ivalue"
            hide-details
            outlined
            v-model="newProperty.ivalue"
            required
          ></v-text-field>
          <label class="add-files_form-label" for="dgvs">Способ получения информации</label>
          <v-autocomplete
            id="dgvs"
            ref="autocomplit"
            :items="getSearch"
            outlined
            v-model="newProperty.dgws"
            auto-select-first
            chips
            clearable
            deletable-chips
            multiple
            small-chips
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  <v-btn color="blue" @click.stop.prevent="saveTags('autocomplit1')">Добавить тэг</v-btn>
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-autocomplete>
          <p>{{selected.length == 1 ? selected[0].fileName : selected.map(item => {return item.fileName}).join(', ')}}</p>
          <v-btn @click="open()" class="mb-2">добавить файл</v-btn>
        </div>
        <div class="form_item">
          <!-- <button @click="savePropertyFile(newProperty)" type="submit" class="form_item-submit">Сохранить</button> -->

          <v-btn :loading="loadingFileProperty" color="#2B56F6" dark large @click="savePropertyFile(newProperty)" block class="form_item-submit">Сохранить</v-btn>
        </div>
      </div>
    </v-dialog>
    
    <v-dialog
      v-model="popup.open"
      max-width="90%"
      height="90%"
     >
      <v-card>
        <v-card-title class="text-h5">
          <div class="add-files_header">
            <h2>{{popup.title}}</h2>
            <button class="filter-btn" @click="popupClose()">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </v-card-title>

        <v-card-text class="d-flex">
          <img height="600" class="image-pop" v-if="popup.image" :src="popup.file" alt="">
          <iframe width="100%" height="600" class="image" v-else :src="popup.file" frameborder="0"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import "./Property.scss";
import _ from 'lodash'
export default {
  name: "Property",
  props: {
    isnormal: Boolean
  },
  data() {
    return {
        loadingFileProperty: false,
      popup: {
        open: false,
        image: true,
        title: '',
        file: '',
      },
      filter: {
        author: '',
        fileType: '',
      },
      page: 1,
      itemsPerPage: 5,
      headers: [
        { text: 'Описание', value: 'description' },
        { text: 'Тeги', value: 'mediaFileTags' },
        { text: 'Файл', value: 'fileName' },
        { text: '', value: 'actions', sortable: false, align: 'right' }
      ],
      headersProperties: [
        {
          text: 'Показатель',
          align: 'left',
          value: 'indicatorName'
        },
        { text: 'Значение', value: 'indicatorValue' },
        { text: 'Способ получения информации', value: 'propertyDGWs' },
        { text: 'Файл', value: 'propertyMediaLinks' },
        { text: '', value: 'created' },
      ],
      propertyDGWs: [1,2],
      dialogProperty: false,
      newProperty: {
        iname: '',
        ivalue: '',
        dgws: [],
        fileids: [],
        nodeid: '',
      },
      query: {
        id: '',
        isnormal: this.isnormal
      },
      selected: [],
      loading: false,
      dialog: false,
      search: '',
      mediaArr:[],
    };
  },
  methods: {
    ...mapActions({
      searchItemsData: 'tree/searchItemsData',
      download: 'media/download',
      createPropertyFile: "property/createPropertyFile",
      updatePropertyFile: "property/updatePropertyFile",
      deletePropertyFiles: "property/deletePropertyFiles",
      getPropertyFiles: "property/getPropertyFiles",
      getFiles: "media/getFiles",
    }),
    ...mapMutations({
      mediaFilter: "media/mediaFilter",
      changeFlagConstructor: "property/changeFlagConstructor"
    }),
    paginations(event) {
      this.page = event.page
      this.itemsPerPage = event.itemsPerPage
    },

    addFiles() {
      this.search = ''
      this.filter.author = ''
      this.filter.fileType = ''
      this.newProperty.fileids = this.selected.map(item => {return item.id})
      this.dialog = false
    },

    openPropertyDialog() {
      this.resetNewProperty()
      this.selected = []
      this.newProperty.nodeid = this.currentNode.id
      this.dialogProperty = true
    },

    closeDialogProperty() {
      this.resetNewProperty()
      this.dialogProperty = false
    },

    resetNewProperty() {
      this.newProperty.iname  = ''
      this.newProperty.ivalue  = ''
      this.newProperty.dgws  = []
      this.newProperty.fileids  = []
      this.newProperty.nodeid  = ''
      this.newProperty.isnormal  = true
    },

    savePropertyFile(query) {
        if(!query.iname || !query.ivalue || query.dgws.length === 0) {
            return;
        }
        this.loadingFileProperty = true;
        this.newProperty.isnormal = this.isnormal;

        this.createPropertyFile(query).then(() => {
            this.resetNewProperty()
            this.dialogProperty = false
            this.getPropertyFiles(this.query)
                .then(() => {
                    this.loadingFileProperty = false;
                })
        })
    },

    open() {
      this.mediaArr = this.mediaData.filter(function(item) {
       const extension = _.last(item.fileName.split('.'))
       return extension !== 'docx'
     })
      this.dialog = true
    },

    editProperty(item) {
      this.getProperty.map(item => {
        item.update = false
      })
      
      this.selected = item.propertyMediaLinks.map(item => {
        return item.mediaFile
      })

      this.propertyDGWs = []
      item.update = true
      item.propertyDGWs.forEach(item => {
        this.propertyDGWs.push(item.dataGetWay.wayName)
      })
    },
    saveEdit(item) {
      this.newProperty = {
        iname: item.indicatorName,
        ivalue: item.indicatorValue,
        dgws: this.propertyDGWs,
        fileids: this.selected.map(item => {return item.id}),
        nodeid: item.id,
        isnormal: this.isnormal
      }
      this.updatePropertyFile(this.newProperty).then(() => {
        this.resetNewProperty()
        this.selected = []
        item.update = false
        this.getPropertyFiles(this.query)
            .then(() => {
                this.loadingFileProperty = false;
            })
      })
    },
    removeEdit(item) {
        item.update = false
    },
    deleteProperty(id) {
      if (confirm("удалить файл?")) {
        this.deletePropertyFiles(id)
      }
    },

    viewing(item) {
      const type = _.last(item.mediaFile.fileUrl.split('.'))
      if (type === 'webb'||type === 'png'||type === 'jpg'|| type === 'jpeg') {
          this.popup.image = true
      } else {
          this.popup.image = false
      }
      this.popup.open = true
      this.popup.title = item.mediaFile.fileName
      this.popup.file = `${this.apiImg}${item.mediaFile.fileUrl}`
    },
    getProperties(bool) {
      this.isnormal = bool
      this.property()
    },
    property() {
     this.query = {
       id: this.currentNode.id,
       isnormal: this.isnormal
     }
     this.getPropertyFiles(this.query)

    },
    downloadFiles(item) {
      this.loading = true
      this.download(item).then(() => this.loading = false)
    },
    link(file) {
      const type = _.last(file.mediaFile.fileName.split('.'))
      return type !== 'docx'
    },

    popupClose() {
      this.popup.open = false
      this.popup.file = ''
      this.popup.title = ''
    },
    close () {
      this.dialog = false
      this.search = ''
      this.filter.author = ''
      this.filter.fileType = ''
      this.getFiles()
    },
  },
  computed: {
    ...mapGetters({
      apiImg: "apiImg",
      userName: "login/userName",
      currentNode: "tree/currentNode",
      getLoadingProperty: "property/getLoadingProperty",
      getSearch: "tree/getSearch",
      mediaData: "media/mediaData",
      mediaDataAutocomplit: "media/mediaDataAutocomplit",
      getProperty: "property/getProperty",
      mediaType: "media/mediaType",
    }),
  },
  mounted() {
    this.query.id = this.currentNode.id
    this.getPropertyFiles(this.query)
        .then(() => {
            this.changeFlagConstructor({ name: 'loadingProperty', value: false });
        })
  },
  created() {
    this.searchItemsData({itemtype: 4, text: ''})
  }
};
</script>
